import { ThemeDefinition } from './theme.models';

export const DEFAULT_THEME: ThemeDefinition = {
  id: 'default',
  name: 'Default',
  light: {
    primary: '#2563eb',
    secondary: '#7c3aed',
    accent: '#f59e0b',
    background: '#f8fafc',
    surface: '#ffffff',
    text: '#1e293b',
    border: '#e2e8f0',
  },
  dark: {
    primary: '#3b82f6',
    secondary: '#8b5cf6',
    accent: '#fbbf24',
    background: '#0f172a',
    surface: '#1e293b',
    text: '#f1f5f9',
    border: '#334155',
  },
};

export const BRAND_THEME: ThemeDefinition = {
  id: 'brand',
  name: 'Brand',
  light: {
    primary: '#059669',
    secondary: '#0891b2',
    accent: '#e11d48',
    background: '#f0fdf4',
    surface: '#ffffff',
    text: '#1e293b',
    border: '#d1fae5',
  },
  dark: {
    primary: '#10b981',
    secondary: '#22d3ee',
    accent: '#fb7185',
    background: '#022c22',
    surface: '#064e3b',
    text: '#ecfdf5',
    border: '#065f46',
  },
};
